import { render, staticRenderFns } from "./app.vue?vue&type=template&id=07370e90&"
import script from "./app.vue?vue&type=script&lang=js&"
export * from "./app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hay/htdocs/git/wiki-tools/public_html/qidquery/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07370e90')) {
      api.createRecord('07370e90', component.options)
    } else {
      api.reload('07370e90', component.options)
    }
    module.hot.accept("./app.vue?vue&type=template&id=07370e90&", function () {
      api.rerender('07370e90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/app.vue"
export default component.exports